export default "__VITE_ASSET__BaCRkIxl__"